import { render } from "./gaji-history.vue?vue&type=template&id=a2f681b0"
import script from "./gaji-history.vue?vue&type=script&lang=js"
export * from "./gaji-history.vue?vue&type=script&lang=js"

import "./gaji-history.vue?vue&type=style&index=0&id=a2f681b0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__